import { render, staticRenderFns } from "./HistoricoComunicacao.vue?vue&type=template&id=24e384d2&scoped=true"
import script from "./HistoricoComunicacao.vue?vue&type=script&lang=ts"
export * from "./HistoricoComunicacao.vue?vue&type=script&lang=ts"
import style0 from "./HistoricoComunicacao.vue?vue&type=style&index=0&id=24e384d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e384d2",
  null
  
)

export default component.exports